
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punemumbaidailycabservice() {



    const cardData =
    {
        keyword: ' Pune Mumbai Daily Cab Service',
        heading: 'Skyline Cabs: Pune Mumbai Daily Cab Service',
        headingDescription: 'Skyline Cabs offers reliable and punctual Pune Mumbai Daily Cab Service for your everyday intercity travel needs. Whether you are commuting for work, meetings, or personal errands, our clean, well-maintained vehicles and professional drivers ensure a comfortable and safe journey every day. With fixed schedules, transparent pricing, and 24/7 customer support, Skyline Cabs makes daily travel between Pune and Mumbai stress-free and convenient. Book your daily cab today and enjoy smooth, on-time rides with complete peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Pune Mumbai Daily Cab Rates",
      "description": "Skyline Cabs offers daily cab services from Pune to Mumbai at competitive rates. We provide safe, timely, and comfortable rides, with vehicles including sedans, SUVs, and luxury options to suit your budget."
    },
    {
      "name": "Pune Mumbai Airport Drop Daily Cab",
      "description": "Book your daily airport drop from Pune to Mumbai with Skyline Cabs. Our reliable drivers ensure you reach Mumbai Airport on time, with transparent pricing and vehicle options based on your comfort."
    },
    {
      "name": "Pune Mumbai Airport Daily One Way Cab",
      "description": "Skyline Cabs offers one-way daily cabs from Pune to Mumbai Airport. Choose from a variety of vehicles like Ertiga, Innova Crysta, and Sedans for a smooth, hassle-free ride at the best rates."
    },
    {
      "name": "Pune to Dadar Daily Cab Service",
      "description": "Skyline Cabs provides daily cab services from Pune to Dadar, ensuring punctual arrivals. Whether you're traveling for business or leisure, our vehicles are equipped for your comfort."
    },
    {
      "name": "Pune to Mumbai Cheapest Cab Service",
      "description": "Looking for an affordable daily cab service from Pune to Mumbai? Skyline Cabs offers budget-friendly rates without compromising on service quality. Book your ride today and enjoy transparent pricing."
    },
    {
      "name": "Pune to Mumbai Cab Travel Time",
      "description": "The travel time from Pune to Mumbai by cab is approximately 3.5 to 4 hours, depending on traffic. Skyline Cabs ensures efficient routes for the fastest journey possible with a comfortable ride."
    },
    {
      "name": "Pune to Mumbai Daily Cab Contact Number",
      "description": "For booking daily cab services from Pune to Mumbai, call Skyline Cabs at [Insert Contact Number]. Our support team is available 24/7 to assist you with your ride."
    },
    {
      "name": "Pune to Mumbai Airport Daily Cab Number",
      "description": "Need a daily ride to Mumbai Airport? Call Skyline Cabs at [Insert Contact Number] for quick, efficient, and reliable airport transfers from Pune to Mumbai with no hassle."
    },
    {
      "name": "Pune to Mumbai Daily Car Hire",
      "description": "Skyline Cabs offers daily car hire services from Pune to Mumbai. Choose from a range of vehicles for your daily commute with options like Innova, Ertiga, and luxury cars for your convenience."
    },
    {
      "name": "Pune to Mumbai Daily Taxi Fare",
      "description": "Skyline Cabs offers affordable daily taxi fares for rides between Pune and Mumbai. We provide fixed pricing with no hidden fees, so you can enjoy a stress-free journey every time."
    },
    {
      "name": "Pimpri Chinchwad to Mumbai Daily Cab Service",
      "description": "Skyline Cabs offers convenient daily cab services from Pimpri Chinchwad to Mumbai. Choose your preferred vehicle for a smooth and comfortable ride at reasonable prices."
    },
    {
      "name": "Pune Mumbai Daily Cab Service",
      "description": "Enjoy daily cab services from Pune to Mumbai with Skyline Cabs. Our expert drivers ensure your trip is pleasant and timely, and we offer multiple vehicle options to suit your needs."
    },
    {
      "name": "Mumbai to Pune Best Taxi Service",
      "description": "Skyline Cabs is known for the best taxi service from Mumbai to Pune. Our professional drivers, clean vehicles, and excellent service quality make us the top choice for intercity travel."
    },
    {
      "name": "Cheapest Cab Mumbai to Pune",
      "description": "Skyline Cabs offers the most affordable rates for your Mumbai to Pune journey. We ensure transparency in pricing while maintaining top-tier service with a fleet of reliable vehicles."
    },
    {
      "name": "Best Cab Service Mumbai to Pune",
      "description": "Skyline Cabs provides premium cab services for your Mumbai to Pune travel. Our fleet includes luxury options like Innova Crysta and Ertiga, alongside economy vehicles for your convenience and comfort."
    }
  ],
  "tableData": [
    ["Pune Mumbai Daily Cab Rates", "Pune Mumbai Airport Drop Daily Cab"],
    ["Pune Mumbai Airport Daily One Way Cab", "Pune to Dadar Daily Cab Service"],
    ["Pune to Mumbai Cheapest Cab Service", "Pune to Mumbai Cab Travel Time"],
    ["Pune to Mumbai Daily Cab Contact Number", "Pune to Mumbai Airport Daily Cab Number"],
    ["Pune to Mumbai Daily Car Hire", "Pune to Mumbai Daily Taxi Fare"],
    ["Pimpri Chinchwad to Mumbai Daily Cab Service", "Pune Mumbai Daily Cab Service"],
    ["Mumbai to Pune Best Taxi Service", "Cheapest Cab Mumbai to Pune"],
    ["Best Cab Service Mumbai to Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Daily Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and timely cab services for daily travel between Pune and Mumbai. Whether it's for work or leisure, our service ensures a smooth and timely ride, every day."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained vehicles such as sedans, SUVs, and luxury cars that provide a comfortable and relaxing journey for your daily commute between Pune and Mumbai. All vehicles are air-conditioned and equipped with ample legroom."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Pune to Mumbai, ensuring that your daily journey is quick, safe, and hassle-free. They are committed to your safety and comfort throughout the ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive pricing for daily Pune to Mumbai cab services. We provide transparent pricing with no hidden charges, ensuring that you get great value for your money while enjoying top-quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether you need to travel early in the morning or late at night, Skyline Cabs operates 24/7, ensuring that you have a reliable ride whenever you need it, every day between Pune and Mumbai."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your Pune to Mumbai cab is quick and easy with Skyline Cabs. Use our website or mobile app to book a ride in minutes, and enjoy instant booking confirmation along with real-time ride tracking."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs for Every Trip",
        "WhyChoosedescription": "We prioritize your health and safety. All of our vehicles are cleaned and sanitized before each trip, and our drivers follow strict safety protocols to ensure you travel in a secure and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles for Your Needs",
        "WhyChoosedescription": "Whether you're traveling alone, with a colleague, or in a group, we offer a variety of vehicles to suit your needs. Choose from sedans for solo travelers, SUVs for a more spacious ride, or luxury cars for an enhanced experience."
    }
]





















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a daily cab service from Pune to Mumbai with Skyline Cabs?',
            answer:
                'Booking a daily cab service from Pune to Mumbai is easy. You can book through our website, mobile app, or by calling our customer support team. Just provide your preferred pickup and drop-off details, select a vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the daily Pune to Mumbai cab service?',
            answer:
                'We offer various vehicle options for your daily commute, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose a vehicle based on your comfort preferences and group size.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Pune to Mumbai?',
            answer:
                'The travel time from Pune to Mumbai typically ranges from 3.5 to 5 hours, depending on traffic. Our drivers ensure the smoothest and most efficient route to get you to your destination on time.',
        },
        {
            id: 4,
            question: 'Are the fares for the daily Pune to Mumbai cab service fixed?',
            answer:
                'Yes, the fares are fixed, transparent, and include tolls, taxes, and driver fees. You will know the total cost upfront before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip daily cab service from Pune to Mumbai?',
            answer:
                'Yes, round-trip bookings are available for your daily commute. Simply provide your return trip details when booking, and we’ll arrange the cab for both trips.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my daily Pune to Mumbai cab booking?',
            answer:
                'Yes, you can modify or cancel your booking through our app, website, or by contacting customer support. We offer flexible options to adjust to your changing plans.',
        },
        {
            id: 7,
            question: 'Are the cabs used for the daily Pune to Mumbai service clean and well-maintained?',
            answer:
                'Absolutely! All our vehicles are regularly cleaned and maintained to ensure a comfortable and safe travel experience. We prioritize your comfort and safety on every ride.',
        },
        {
            id: 8,
            question: 'What payment options are available for the daily Pune to Mumbai cab service?',
            answer:
                'You can pay using UPI, credit/debit cards, net banking, or cash. All online payments are secure and hassle-free, and cash payments are accepted at the end of the trip.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate daily travel from Pune to Mumbai?',
            answer:
                'Yes, we offer reliable corporate travel services for daily commutes between Pune and Mumbai. Contact us for tailored solutions to fit your business requirements.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my daily Pune to Mumbai journey?',
            answer:
                'Skyline Cabs is known for its punctual service, professional drivers, well-maintained vehicles, and transparent pricing. We ensure a smooth, comfortable, and timely commute every day from Pune to Mumbai.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I’ve been using Skyline Cabs for my daily commute between Pune and Mumbai. The service is always reliable, the drivers are professional, and the vehicles are comfortable. Highly recommend!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Good experience with the daily Pune to Mumbai cab service. The vehicle was clean and well-maintained. Sometimes, the traffic can cause delays, but the driver did a great job managing the route."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Daily Cab",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-daily-cab.jpg",
  "description": "Book Pune to Mumbai daily cab with Skyline Cabs for hassle-free, affordable, and punctual travel. Choose from AC sedans, SUVs, or luxury vehicles—available every day with professional drivers and fixed fare.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8734"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1250",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-daily-cab"
  }
};



      
     
      

    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Daily Cab | Fixed Fare & Daily Pickup | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai daily cab with Skyline Cabs for hassle-free, affordable, and punctual travel. Choose from AC sedans, SUVs, or luxury vehicles—available every day with professional drivers and fixed fare." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Daily Cab, Daily Cab Service Pune to Mumbai, Fixed Fare Cab Pune to Mumbai, AC Taxi Pune to Mumbai, Daily Pickup Pune to Mumbai, SUV Cab Pune to Mumbai, Online Cab Booking Daily Pune Mumbai, Skyline Cabs Daily Service, Pune Mumbai Daily Taxi, Everyday Cab Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/64.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punemumbaidailycabservice;